// https://en.wikipedia.org/wiki/International_System_of_Units#Prefixes
export const Multiples = Object.freeze({
  deca: "d",
  hecto: "c",
  kilo: "k",
  mega: "M",
  giga: "G",
  // ...
});
export const Submultiples = Object.freeze({
  deci: "d",
  centi: "c",
  milli: "m",
  // µm
  // nm
  // ...
});
